<rt-button
  #bulkActionsDropdownTrigger="rtOverlayOrigin"
  [variant]="variant"
  [disabled]="disabled"
  [dropdownOpened]="dropdownOpened"
  [ngClass]="{ 'is-first': active, dropdownOpened: dropdownOpened }"
  (click)="toggleDropdown()"
  rt-overlay-origin
>
  <rt-checkbox
    [indeterminateState]="indeterminateState"
    [checked]="allSelected"
    [disabled]="disabled"
    (valueChange)="select.emit(!!$event)"
  >
    <span *ngIf="selectedCount > 0">{{ selectedCount }}</span>
  </rt-checkbox>
</rt-button>

<ng-template
  [open]="dropdownOpened"
  [origin]="bulkActionsDropdownTrigger"
  [rtConnectedOverlayPosition]="OverlayPosition.BottomLeft"
  (backdropClick)="toggleDropdown(false)"
  rt-connected-overlay
  [rtConnectedOverlayAutoClose]="false"
  [hasBackdrop]="true"
>
  <rt-dropdown [width]="DropdownWidth.SmallXX">
    <rt-dropdown-item (click)="select.emit(true); toggleDropdown(false)">
      {{ 'rtu.common.bulk_select.all' | translate }}
    </rt-dropdown-item>
    <rt-dropdown-item (click)="select.emit(false); toggleDropdown(false)">
      {{ 'rtu.common.bulk_select.none' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
